import type Phaser from 'phaser';
import { portraitKey } from './assets';
import { loaderCritter } from './glenLoadPlan';
import { rasterUrl } from './raster';

let faceImage: HTMLImageElement | null = null;
let faceFor: string | null = null;
let faceTask: Promise<void> | null = null;

function decode(src: string): Promise<HTMLImageElement> {
  const image = new Image();
  const done = new Promise<HTMLImageElement>((resolve, reject) => {
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('loader portrait'));
  });
  image.src = src;
  if (image.decode) return image.decode().then(() => image);
  return done;
}

/** One packed portrait, only if boot has not already decoded that critter. */
export function preloadLoaderPortrait(alreadyLoaded = false): Promise<void> {
  if (alreadyLoaded) return Promise.resolve();
  const id = loaderCritter();
  if (faceTask && faceFor === id) return faceTask;
  faceFor = id;
  faceImage = null;
  if (typeof Image === 'undefined') {
    faceTask = Promise.resolve();
    return faceTask;
  }
  const path = `assets/heroes/cc_hero_${id}_portrait_round@2x.png`;
  const packed = rasterUrl(path);
  const load = (url: string) => decode(url);
  faceTask = load(packed)
    .catch(() => (packed === path ? Promise.reject(new Error('portrait')) : load(path)))
    .then((image) => {
      faceImage = image;
    })
    .catch(() => undefined);
  return faceTask;
}

/**
 * The wooden leafy frame is the title pack's portrait frame.
 * The face is whichever critter this visit chose, already in memory when boot finished.
 */
export async function installLoaderPortrait(scene: Phaser.Scene): Promise<void> {
  const id = loaderCritter();
  const faceKey = portraitKey(id);
  const haveFace = scene.textures.exists(faceKey);
  await preloadLoaderPortrait(haveFace);
  if (!scene.textures.exists(faceKey) && faceImage && faceImage.naturalWidth > 8) {
    scene.textures.addImage(faceKey, faceImage);
  }
}
